// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { useEffect } from 'react';
import { MouseSmooth } from 'react-mouse-smooth';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { GlobalStyled } from './assets/styles/global';
import { theme } from './assets/styles/theme';
import routes from './config/routes';
import { Analytics } from '@vercel/analytics/react';
import useScreenSize from 'hooks/useScreenSize';
import { ThemeProvider } from 'styled-components';
import './assets/fonts/SF Pro Display/sf-pro-display.css';
import './assets/fonts/SF Pro Text/sf-pro-text.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const screenSize = useScreenSize();

  const isMobileQuery = () => {
    if (screenSize === 'md' || screenSize === 'sm' || screenSize === 'xs') {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (!isMobileQuery()) {
      MouseSmooth({});
    }

    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenSize]);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {routes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <route.component
                    key={index}
                    name={route.name}
                    {...route.props}
                  />
                }
              />
            );
          })}
        </Routes>
      </Router>
      <GlobalStyled />
      <ToastContainer />
      <Analytics />
    </ThemeProvider>
  );
}

export default App;
